import React from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'

import getByPath from 'lodash/get'
import moment from 'moment'

import TransportationForm from './TransportationForm'
import { TextInput, TextEditor, TimePicker } from '../UI'
import PlacesAutocomplete from './PlacesAutocomplete'

import { defaultDate } from './index'

class CarRental extends TransportationForm {
  static propTypes = {
    ...TransportationForm.propTypes,
    t: PropTypes.func
  }

  static defaultProps = {
    ...TransportationForm.defaultProps
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { dates, onFormFieldChange, form, t } = this.props

    const departureInputProps = {
      value: this.state.departure,
      placeholder: t('location_placeholder'),
      onChange: departure => {
        this.setState({ departure })
      }
    }

    const arrivalInputProps = {
      value: this.state.arrival,
      placeholder: t('location_placeholder'),
      onChange: arrival => {
        this.setState({ arrival })
      }
    }

    return (
      <div id="car-rental-form" className="event__form--hidden">
        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('location_and_time_label')}</h2>

          <div className="form-group">
            <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label">
              {t('pick_up_location_label')}
            </label>
            <PlacesAutocomplete
              inputProps={departureInputProps}
              onSelect={(place, placeId) => this.onPlaceChange(place, placeId, 'departure')}
            />
          </div>

          {!!this.state.departureAddress && (
            <div className="form-group">
              <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label" />
              <div className="col-md-9">
                <div className="formatted-address">{this.state.departureAddress}</div>
              </div>
            </div>
          )}

          <div className="mb-0 form-group">
            <label htmlFor="car-rental-pick-up-day" className="event__form-label col-md-3 control-label">
              {t('date_day_label')}
            </label>
            <div className="col-md-4">
              <select
                id="car-rental-pick-up-day"
                className="form-control event__form-input"
                value={this.state.departureDate && this.state.departureDate.toISOString()}
                onChange={e => this.onDateChange('departureDate', e.target.value, true)}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip ? `${moment(day.dayOfTrip).format('MMM D')} / ` : ''}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-5">
              <TimePicker
                id="departureTime"
                value={this.state.departureTime && this.state.departureTime.toDate()}
                onChange={(id, value) => this.onDateChange(id, value)}
                label={t('time')}
                labelClass="event__form-label col-md-3 control-label"
                extraClass="col-md-9"
              />
            </div>
          </div>

          <TextInput
            label={t('link__label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-9"
            id="contentPOIs[0].website"
            initialValue={getByPath(form, 'contentPOIs[0].website', '')}
            extraClass="form-control event__form-input"
            placeholder={t('link__placeholder')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />

          <div className="form-group">
            <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label">
              {t('drop_off_location_label')}
            </label>
            <PlacesAutocomplete
              inputProps={arrivalInputProps}
              onSelect={(place, placeId) => this.onPlaceChange(place, placeId, 'arrival')}
            />
          </div>

          {!!this.state.arrivalAddress && (
            <div className="form-group">
              <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label" />
              <div className="col-md-9">
                <div className="formatted-address">{this.state.arrivalAddress}</div>
              </div>
            </div>
          )}

          <div className="mb-0 form-group">
            <label htmlFor="car-rental-drop-off-day" className="event__form-label col-md-3 control-label">
              {t('date_day_label')}
            </label>
            <div className="col-md-4">
              <select
                id="car-rental-drop-off-day"
                className="form-control event__form-input"
                value={this.state.arrivalDate && this.state.arrivalDate.toISOString()}
                onChange={e => this.onDateChange('arrivalDate', e.target.value, true)}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip ? `${moment(day.dayOfTrip).format('MMM D')} / ` : ''}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-5">
              <TimePicker
                id="arrivalTime"
                value={this.state.arrivalTime && this.state.arrivalTime.toDate()}
                onChange={(id, value) => this.onDateChange(id, value)}
                label={t('time')}
                labelClass="event__form-label col-md-3 control-label"
                wrapperClass="mb-0"
                extraClass="col-md-9"
              />
            </div>
          </div>
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('description_label')}</h2>
          <div className="event__example-container">
            <i className="icon-flag event__example-icon" /> <span className="event__example-text">{t('description_example')}</span>
          </div>
          <TextEditor
              id="editor"
              value={form.description}
              placeholder={t('description_placeholder')}
              onChange={(content, delta, source, editor) => {
                onFormFieldChange('description', content)
              }}
          />


        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('price')}</h2>
          <div className="form-group">
            <label htmlFor="activity-amount" className="event__form-label col-md-3 control-label">
              {t('amount_label')}
            </label>
            <div className="col-md-3">
              <input
                type="text"
                value={form.price}
                id="activity-amount"
                className="form-control event__form-input"
                placeholder={t('amount_placeholder')}
                onChange={e => (isNaN(+e.target.value) ? null : onFormFieldChange('price', +e.target.value))}
              />
            </div>
            <label htmlFor="car-rental-currency" className="event__form-label col-md-2 control-label">
              {t('currency_label')}
            </label>
            <div className="col-md-3">
              <select
                id="car-rental-currency"
                value={form.currency}
                className="form-control event__form-input"
                onChange={e => onFormFieldChange('currency', e.target.value)}
              >
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="NIS">NIS</option>
              </select>
            </div>
          </div>
          <TextInput
            label={t('book_through_label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-6"
            id="eventDetails.bookedThrough"
            initialValue={getByPath(form, 'eventDetails.bookedThrough', '')}
            extraClass="form-control event__form-input"
            placeholder={t('book_through_placeholder')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
          <TextInput
            label={t('confirmation_number_label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-6"
            id="eventDetails.confirmationCode"
            initialValue={getByPath(form, 'eventDetails.confirmationCode', '')}
            extraClass="form-control event__form-input"
            placeholder={t('confirmation_number_placeholder')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
          <TextInput
            label={t('carrier_label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-6"
            id="eventDetails.transportationDetails.carrier"
            initialValue={getByPath(form, 'eventDetails.transportationDetails.carrier', '')}
            extraClass="form-control event__form-input"
            placeholder="Type"
            wrapperClass="mb-0"
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
        </div>
      </div>
    )
  }
}

export default compose(
  translate('event', {
    withRef: true
  })
)(CarRental)



// WEBPACK FOOTER //
// src/components/Event/CarRental.js